/**
 * Compact "X ago" formatter — e.g. "12m", "4h", "2w", "3mo".
 *
 * Returns a short token (default) suitable for dense UI like badges and rows,
 * or with an " ago" suffix when `withSuffix` is true.
 */
export function formatRelativeShort(iso: string, withSuffix = false): string {
  const then = new Date(iso).getTime()
  if (Number.isNaN(then)) return ''
  const diffMs = Date.now() - then
  const minutes = Math.floor(diffMs / 60_000)

  let token: string
  if (minutes < 1) return withSuffix ? 'just now' : 'now'
  if (minutes < 60) token = `${minutes}m`
  else {
    const hours = Math.floor(minutes / 60)
    if (hours < 24) token = `${hours}h`
    else {
      const days = Math.floor(hours / 24)
      if (days < 7) token = `${days}d`
      else {
        const weeks = Math.floor(days / 7)
        if (weeks < 5) token = `${weeks}w`
        else {
          const months = Math.floor(days / 30)
          if (months < 12) token = `${months}mo`
          else {
            const years = Math.floor(days / 365)
            token = `${years}y`
          }
        }
      }
    }
  }
  return withSuffix ? `${token} ago` : token
}
